import React, { useState } from 'react';
import { Flame, Loader2 } from 'lucide-react';
import { toast } from 'sonner';
import { api } from '../../lib/api';
import { useLanguage } from '../../i18n';
import { Dialog, DialogContent, DialogHeader, DialogTitle } from '../ui/dialog';

export const ShareDialog = ({ open, onOpenChange, analysisId, onShared }) => {
  const { t } = useLanguage();
  const [caption, setCaption] = useState('');
  const [sharing, setSharing] = useState(false);

  const sharePost = async () => {
    setSharing(true);
    try {
      const { data: p } = await api.post('/pitch/posts', { analysis_id: analysisId, caption });
      onShared(p.post_id);
      onOpenChange(false);
      toast.success(t('sharedOnPitch'));
    } catch (err) {
      console.error('Share on Pitch failed:', err);
      toast.error(err.response?.data?.detail || t('analysisFailedSub'));
    } finally {
      setSharing(false);
    }
  };

  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="bg-[#1E1E1E] border-white/10 rounded-[16px] max-w-sm" data-testid="result-share-dialog">
        <DialogHeader>
          <DialogTitle className="font-display text-white">{t('shareOnPitch')}</DialogTitle>
        </DialogHeader>
        <textarea
          value={caption}
          onChange={(e) => setCaption(e.target.value)}
          placeholder={t('captionPlaceholder')}
          maxLength={300}
          rows={3}
          data-testid="result-share-caption"
          className="w-full rounded-[14px] bg-white/[0.04] border border-white/10 p-3 text-sm text-white placeholder:text-white/30 resize-none focus:outline-none"
        />
        <button onClick={sharePost} disabled={sharing} data-testid="result-share-confirm" className="ss-btn-primary w-full h-11 text-sm font-bold font-display flex items-center justify-center gap-2">
          {sharing ? <Loader2 size={15} className="animate-spin" /> : <Flame size={15} />} {t('share')}
        </button>
      </DialogContent>
    </Dialog>
  );
};
